module.exports = __webpack_public_path__ + "img/shopping-bag-03.62809eeb.svg";